import { Config } from './dtos/Config.dto';

export const fetchConfig = async (): Promise<Config> => {
  const { config } = await fetch('/config.json').then((response) => response.json());
  return config;
};
